import React from 'react';

export const SchemaValidationErrorMessage = () => {
    return (
        <div className="spark-message spark-message--error">
            <i className="spark-message__icon spark-icon-ban spark-icon--fill"></i>
            <div className="spark-message__content">
                <b>Errors were found. </b>
                <span className="spark-message--info">Please correct the errors before saving the file.</span>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/SchemaValidationErrorMessage.js